import Nullstack from 'nullstack';
export default function IconCalendarOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-calendar-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.175 -1.823m3.825 -.177h9a2 2 0 0 1 2 2v9"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "3",
    x2: "16",
    y2: "7"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "3",
    x2: "8",
    y2: "4"
  }), "   ", Nullstack.element("path", {
    d: "M4 11h7m4 0h5"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "15",
    x2: "12",
    y2: "15"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "18"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "3",
    x2: "21",
    y2: "21"
  }), " ");
}